import {Inject, Injectable} from '@angular/core'; 
import { Meta, Title } from '@angular/platform-browser';
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from 'src/environments/model/environment.model';

@Injectable({
  providedIn: 'root'
})

export class SmartLinkService {
  constructor(
    private title: Title,
    private meta: Meta,
    @Inject(ENVIRONMENT_CONFIG) public environment: EnvironmentConfiguration
  ) { }


  updateTitle(id: number, siteTitle: string, siteName: string) {
    let trimmedTitle = siteTitle;
    if (siteTitle.length > 30) {
      trimmedTitle = siteTitle.substring(0, 30) + '...';
    }
    const formattedTitle = `${id}: ${trimmedTitle} - ${siteName}`;
    this.updateMetaData(formattedTitle);
  }


  updateMetaData(title: string){
    let siteName = this.getSiteNameByEnvironment();
    const titleWithSiteName = `${title} - ${siteName}`;
    this.title.setTitle(titleWithSiteName);
  }

  
  getSiteNameByEnvironment(): string{
    switch(this.environment.name){
      case 'local':
        return 'HRT Connect(Local)'
      case 'dev':
        return 'HRT Connect(DEV)'
      case 'test':
        return 'HRT Connect(TEST)'
      case 'uat':
        return 'HRT Connect(UAT)'
      default:
        return 'HRT Connect'
    }
  }


}